import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOtherproduct = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.00039 7.99998C6.55249 8.00019 7.00038 8.44783 7.00039 8.99998C7.00039 9.55213 6.5525 9.99977 6.00039 9.99998C5.44811 9.99998 5.00039 9.55226 5.00039 8.99998C5.0004 8.4477 5.44811 7.99998 6.00039 7.99998Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.00039 7.99998C9.55249 8.00019 10.0004 8.44783 10.0004 8.99998C10.0004 9.55213 9.5525 9.99977 9.00039 9.99998C8.4481 9.99998 8.00039 9.55226 8.00039 8.99998C8.0004 8.4477 8.44811 7.99998 9.00039 7.99998Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0004 7.99998C12.5525 8.00019 13.0004 8.44783 13.0004 8.99998C13.0004 9.55213 12.5525 9.99977 12.0004 9.99998C11.4481 9.99998 11.0004 9.55226 11.0004 8.99998C11.0004 8.4477 11.4481 7.99998 12.0004 7.99998Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.29336 0.707011C8.65939 0.341266 9.23858 0.317687 9.63125 0.637675L9.70742 0.707011L17.2934 8.29295L17.3617 8.36814C17.6822 8.76092 17.6595 9.34181 17.2934 9.70799L9.70742 17.2939L9.63125 17.3613C9.26461 17.6605 8.73519 17.6605 8.36855 17.3613L8.29336 17.2939L0.706445 9.70799L0.638085 9.63084C0.339356 9.2642 0.339049 8.73461 0.638085 8.36814L0.706445 8.29295L8.29336 0.707011ZM1.41348 8.99998L8.99941 16.5859L16.5863 8.99998L9.00039 1.41404L1.41348 8.99998Z",
			fill: "black"
		})
	]
});
export default SvgOtherproduct;
